import { lazy } from 'react';

export const EmailConfirmCongratulationsLazy = lazy(
  () => import('./EmailConfirmCongratulations')
);
